module.exports = __webpack_public_path__ + "media/images/preview-9a17d32fc48369e8ccd910a75260e67d.jpg";